var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverytimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "deliverytime-icon.fce0a469",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M17.643,12.856l-.592-.609a.127.127,0,0,0-.094-.04h0a.122.122,0,0,0-.094.04l-4.106,4.136-1.494-1.494a.13.13,0,0,0-.188,0l-.6.6a.134.134,0,0,0,0,.192l1.885,1.885a.6.6,0,0,0,.394.192.625.625,0,0,0,.39-.185h0l4.5-4.523A.144.144,0,0,0,17.643,12.856Z",
    transform: "translate(-3.681 -4.604)",
    fill: "#e10092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M10.375,4.317A6.055,6.055,0,1,1,6.091,6.091a6.055,6.055,0,0,1,4.284-1.774m0-.942a7,7,0,1,0,7,7A7,7,0,0,0,10.375,3.375Z",
    fill: "#e10092"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverytimeIcon);
export default __webpack_public_path__ + "static/media/deliverytime-icon.9b8f03df21d8d7191c4200207f53a059.svg";
export { ForwardRef as ReactComponent };